import React from "react";
import "../../Css/Product.css";
import munafaImage from "../../Assets/munafa.png.png";
const Product = () => {
  return (
    <section className="product-section">
      {/* Background Glow */}
      <div className="product-glow"></div>

      <div className="product-container">
        {/* ===== TOP HEADING ===== */}
        <div className="product-top">
          <div className="product-badge">
            <span className="product-dot"></span>
            OUR MAIN PRODUCT
          </div>

          <h2 className="product-title">
            Introducing <span>Munafa</span>
          </h2>

          <p className="product-subtitle">
            Smart Billing & Inventory Management
          </p>
        </div>

        {/* ===== CONTENT SECTION ===== */}
        <div className="product-content">
          {/* ===== LEFT IMAGE ===== */}
          <div className="product-left">
            <div className="product-image-card">
              <img
                src={munafaImage}
                alt="Munafa Software"
                className="product-image"
              />

              {/* Floating Cards */}
              <div className="floating-card top-card">
                <h4>Inventory</h4>
                <p>Live Stock Updates</p>
              </div>

              <div className="floating-card bottom-card">
                <h4>Billing</h4>
                <p>Smart Invoice System</p>
              </div>
            </div>
          </div>

          {/* ===== RIGHT CONTENT ===== */}
          <div className="product-right">
            <h3 className="product-name">Munafa</h3>

            <p className="product-description">
              A smart billing and inventory management software specially
              designed for businesses like clothing stores, retail shops, and
              other local businesses. Streamline operations, boost efficiency,
              and grow your business with our comprehensive solution.
            </p>

            {/* FEATURES */}
            <div className="product-features">
              <div className="feature-box">
                <div className="feature-icon">💳</div>

                <div>
                  <h4>Intelligent Billing</h4>
                  <p>Fast, accurate invoice generation</p>
                </div>
              </div>

              <div className="feature-box">
                <div className="feature-icon">📦</div>

                <div>
                  <h4>Stock Management</h4>
                  <p>Real-time inventory tracking</p>
                </div>
              </div>

              <div className="feature-box">
                <div className="feature-icon">👥</div>

                <div>
                  <h4>Customer Management</h4>
                  <p>Build lasting customer relationships</p>
                </div>
              </div>

              <div className="feature-box">
                <div className="feature-icon">📊</div>

                <div>
                  <h4>Sales Analytics</h4>
                  <p>Detailed reports and insights</p>
                </div>
              </div>
            </div>

            {/* BUTTON */}
         <a
  href="https://ecommobileappreactnative.firebaseapp.com/"
  target="_blank"
  rel="noopener noreferrer"
  className="explore-btn"
>
  Explore Munafa →
</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
